import { useEffect } from 'react';
import { useGlobalLoading } from './GlobalLoadingContext';
import { setLoadingCallbacks } from '../../api/api';

// Компонент для связывания api с глобальным loading контекстом
const GlobalLoadingConnector = () => {
  const { startLoading, stopLoading } = useGlobalLoading();

  useEffect(() => {
    // Регистрируем callbacks при монтировании
    setLoadingCallbacks(startLoading, stopLoading);
    
    // Очищаем при размонтировании
    return () => {
      setLoadingCallbacks(null, null);
    };
  }, [startLoading, stopLoading]);

  return null; // Этот компонент ничего не рендерит
};

export default GlobalLoadingConnector;
